import React, { useState, useEffect } from "react";
import {NavLink} from "react-router-dom";
import "new_assets/fonts/fonts.css";
import "new_assets/fonts/fonts.css";
import "new_assets/fonts/font-icons.css";
import "new_assets/css/swiper-bundle.min.css";
import "new_assets/css/animate.css";
import "new_assets/css/styles.css";
import "new_assets/images/logo/favicon.png";
import "new_assets/css/jquery.fancybox.min.css";

import "new_components/Footer/Footer.scss";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";

import axios from "axios";
const Footer = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.footers);
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          setData(response.data.data[0]);
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to fetch data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  return (
    <div className="footer py-5">
      <div className="container-fluid">
        <div className="row m-0">
          <div className="col-12 col-md-2 text-center text-md-start mb-4 mb-md-0">
            <NavLink to="/">
              <img
                src={`${Image_Base_URL}${data.logo}`}
                alt="Logo"
                className="footer-logo"
              />
            </NavLink>
            {/* <a href="/">
              <img
                src={`${Image_Base_URL}${data.logo}`}
                alt="Logo"
                className="footer-logo"
              />
            </a> */}
          </div>

          <div className="col-12 col-md-8 d-flex flex-column justify-content-center">
            <div className="row mb-3 mt-2 flex-lg-nowrap justify-content-center">
              {/* <div className="col-6 col-sm-4 col-lg-auto text-center hor-div">
                <a href="/" className="footer-link">
                  Home
                </a>
              </div> */}
              <div className="col-6 col-sm-4 col-lg-auto text-center align-items-center justify-content-center hor-div">
                <a href="/services/development" className="footer-link">
                  Development
                </a>
              </div>
              <div className="col-6 col-sm-4 col-lg-auto text-center hor-div">
                <a href="/services/builders" className="footer-link">
                  Builders
                </a>
              </div>
              <div className="col-6 col-sm-4 col-lg-auto text-center hor-div">
                <a href="/services/asset-management" className="footer-link">
                  Asset Management
                </a>
              </div>
              <div className="col-6 col-sm-4 col-lg-auto text-center hor-div">
                <a href="/services/advisory-services" className="footer-link">
                  Advisory Services
                </a>
              </div>
              <div className="col-6 col-sm-4 col-lg-auto text-center hor-div">
                <a href="/about-us" className="footer-link">
                  About Us
                </a>
              </div>
              {/* <div className="col-6 col-sm-4 col-lg-auto text-center hor-div">
                <a href="/careers" className="footer-link">
                  Careers
                </a>
              </div> */}
              <div className="col-6 col-sm-4 col-lg-auto text-center hor-div">
                <a href="/insights" className="footer-link">
                  Insights
                </a>
              </div>
              <div className="col-6 col-sm-4 col-lg-auto text-center hor-div">
                <a href="/investor-relations" className="footer-link">
                  Investor Relations
                </a>
              </div>
              <div className="col-6 col-sm-4 col-lg-auto text-center hor-div">
                <a href="/contact-us" className="footer-link">
                  Contact Us
                </a>
              </div>
            </div>

            <div className="row">
              <div className="col text-center">
                <div className="d-flex justify-content-center align-items-center">
                  <p className="m-0 me-md-5 me-2 text-footer">
                    {data.copyright_text}
                  </p>
                  <p className="m-0 ">
                    <a
                      href="/privacy-policy"
                      className="footer-link text-footer"
                    >
                      Privacy Policy
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-2 align-items-center align-items-md-end d-flex flex-column align-items-center justify-content-center mt-4 mt-md-0">
            <div className="row">
              <div className="d-flex align-items-center mb-3 mt-2">
                <div className="text-white me-2 text-footer">Follow Us:</div>
                <a
                  href={data.linkedin_link}
                  target="_blank"
                  rel="noreferrer"
                  className="box-icon w-40 social"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.58151 16H0.264292V5.31762H3.58151V16ZM1.92111 3.86044C0.860376 3.86044 0 2.98185 0 1.92111C7.59231e-09 1.4116 0.202403 0.92296 0.562681 0.562681C0.92296 0.202403 1.4116 0 1.92111 0C2.43063 0 2.91927 0.202403 3.27955 0.562681C3.63983 0.92296 3.84223 1.4116 3.84223 1.92111C3.84223 2.98185 2.98149 3.86044 1.92111 3.86044ZM15.9968 16H12.6867V10.7999C12.6867 9.56057 12.6617 7.97125 10.962 7.97125C9.23735 7.97125 8.97306 9.31771 8.97306 10.7106V16H5.65941V5.31762H8.84091V6.77479H8.88734C9.33021 5.93549 10.412 5.04976 12.026 5.04976C15.3832 5.04976 16.0004 7.26052 16.0004 10.132V16H15.9968Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </div>
            </div>

            <div className="row">
              <div className="d-flex justify-content-center">
                <p className="m-0 text-footer py-2">{data.powered_by_text}</p>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
  );
};

export default Footer;
